// Framework & Third-pary
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { WrappedComponentProps, FormattedMessage } from "react-intl";
import Loader from "react-loader-spinner";
import {
	PrimaryButton,
	TextField,
} from "@fluentui/react";

// Images
import teamtailorImage from "../../../../../assets/images/teamtailor-logo.png";

// Models
import { SuccessTypes, ErrorTypes } from "../../../../../models/enums";
import { IApplicationState } from "../../../../../models/interfaces/IApplicationState";

// Components & functions
import { Formik } from "formik";
import { createConnection, updateConnectionById } from "../../../../../store/connection/actions";
import { IUpdateConnection } from "../../../../../models/responseModels/connection/IUpdateConnection";
import { IUpdateConnectionValue } from "../../../../../models/responseModels/connection/IUpdateConnectionValue";
import { IAddConnectionValue } from "../../../../../models/responseModels/connection/IAddConnectionValue";
import { IAddConnection } from "../../../../../models/responseModels/connection/IAddConnection";
import { ConnectionType } from "../../../../../models/enums/ConnectionType";

export interface TeamtailorTileProps {
	intl: WrappedComponentProps["intl"];
}

export const TeamtailorTile = (props: TeamtailorTileProps) => {
	const settingsSlice = useSelector((state: IApplicationState) => state.settingsSlice);
	const connectionSlice = useSelector((state: IApplicationState) => state.connectionSlice);
	const dispatch = useDispatch();

	const handleSubmit = (values) => {
		let connections = connectionSlice.connections.data.filter((d) => d.name === "Teamtailor");
		if (connections.length > 0) {
			//update
			let updateValues: IUpdateConnectionValue[] = [
				{
					key: "ApiKey",
					value: values.ApiKey,
				},
			];

			let updateConnection: IUpdateConnection = {
				id: connections[0].id,
				values: updateValues,
			};
			dispatch(updateConnectionById(updateConnection));
		} else {
			//create
			let createValues: IAddConnectionValue[] = [
				{
					key: "ApiKey",
					value: values.ApiKey,
				},
			];

			let createCon: IAddConnection = {
				name: "Teamtailor",
				connectionTypeId: ConnectionType.Teamtailor,
				values: createValues,
			};
			dispatch(createConnection(createCon));
		}
	};

	const renderTeamtailorContentUi = () => {
		if (settingsSlice.isLoading) {
			return (
				<div className="loaderWrapper">
					<Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
				</div>
			);
		}

		let initialValues = {
			ApiKey: "",
		};

		let connections = connectionSlice.connections.data.filter((d) => d.name === "Teamtailor");
		if (connections && connections.length > 0) {
			let connection = connections[0];

			if (connection.values && connection.values.length > 0) {
				let apiKey =
					connection.values.filter((c) => c.key === "ApiKey").length > 0
						? connection.values.filter((c) => c.key === "ApiKey")[0].value
						: "";

				initialValues = {
					ApiKey: apiKey !== null ? apiKey : "",
				};
			}
		}

		return (
			<div className="youSettings">
				<div className="youSettings-topdesk-logo">
					<img src={teamtailorImage} alt="Topdesk logo" />
					<h1>
						<FormattedMessage id="settings.you.teamtailor.title" defaultMessage="Teamtailor connecties" />
					</h1>
				</div>

				<Formik
					initialValues={initialValues}
					enableReinitialize
					onSubmit={handleSubmit}
				>
					{(formikProps) => {
						const { values, errors, isSubmitting, setSubmitting, handleSubmit, handleChange, handleBlur } = formikProps;
						if (
							isSubmitting &&
							(connectionSlice.success.type !== SuccessTypes.None || connectionSlice.error.type !== ErrorTypes.None)
						) {
							setSubmitting(false);
						}
						return (
							<div className="ilx-form-wrapper">
								<form onSubmit={handleSubmit}>
									<TextField
										id="ApiKey"
										label={props.intl.formatMessage({
											id: "settings.you.teamtailor.api.key",
											defaultMessage: "API key",
										})}
										type="password"
										errorMessage={errors.ApiKey}
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.ApiKey}
										className="ilx-text-field-small"
										autoComplete="Off"
									/>

									<PrimaryButton type="submit" disabled={isSubmitting}>
										<FormattedMessage id="general.save" defaultMessage="Opslaan" />
									</PrimaryButton>
								</form>
							</div>
						);
					}}
				</Formik>
			</div>
		);
	};

	return (
		<div className="settings-setting-wrapper" test-name="settings-tile">
			<div className="settings-tile-body form-wrapper">{renderTeamtailorContentUi()}</div>
		</div>
	);
};
